import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const session_id = m[1];
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        setUser(res.data);
        const dest = loc.pathname || "/";
        window.history.replaceState(null, "", dest);
        nav(dest, { replace: true, state: { user: res.data } });
      } catch (e) {
        setErr("No se pudo iniciar sesión.");
      }
    })();
  }, [loc.hash, loc.pathname, nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-white/60">
      {err ? err : "Iniciando sesión..."}
    </div>
  );
}
